module.exports = __webpack_public_path__ + "static/media/icon_words-to-minutes.baa59ac9.svg";